// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"3babd9ee","526":"098ed25d"}[chunkId] + ".chunk.css";
};